import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

import { IonicVue } from '@ionic/vue';
// import { defineCustomElements } from '@ionic/pwa-elements/loader';

/* Ionic CSS */
import '@ionic/vue/css/core.css';
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optionales CSS */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme Variablen */
import './theme/variables.css';

/* Ionicons */
import { addIcons } from 'ionicons';
import * as allIcons from 'ionicons/icons';
import BaseLayout from "@/components/base/BaseLayout.vue";

/* Alle Icons hinzufügen */
addIcons(allIcons);

const app = createApp(App)
    .use(IonicVue)
    .use(router);

/* Laden der Ionic PWA Elemente (optional, wenn Sie Plugins wie Kamera verwenden) */
// defineCustomElements(window);

app.component('base-layout', BaseLayout);

router.isReady().then(() => {
    app.mount('#app');

});
